import themeGet from '@styled-system/theme-get';
import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box/Box';
import { Flex } from '../Flex/Flex';
import { Hide } from '../Hide/Hide';
import { applyVariations, color, getPaletteColor, hasPaletteColor } from '../utils/utils';
const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);
const shadowColor = props => {
  const darkColor = hasPaletteColor(props) ? getPaletteColor('dark')(props) : themeGet(`colors.dark${capitalize(props.color)}`)(props);
  return {
    backgroundImage: !darkColor ? `
        linear-gradient(45deg, transparent 50%, rgba(0, 0, 0, 0.5) 50%),
        linear-gradient(45deg, transparent 50%, ${props.color} 50%)
      ` : `linear-gradient(45deg, transparent 50%, ${darkColor} 50%)`
  };
};
const FlagShadow = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Flag__FlagShadow",
  componentId: "sc-e0jgig-0"
})(["width:8px;height:8px;align-self:flex-end;background-color:inherit;", ";position:absolute;bottom:0;"], shadowColor);
const FlagRight = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Flag__FlagRight",
  componentId: "sc-e0jgig-1"
})(["flex:none;background-color:", ";border-radius:0 ", " ", " 0;transform:skew(-14deg);position:relative;z-index:1;"], props => getPaletteColor('base')(props) || props.color, themeGet('radius'), themeGet('radius'));
const flexAuto = props => props.flexAuto ? {
  flex: '1 1 auto'
} : null;
const FlagBody = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Flag__FlagBody",
  componentId: "sc-e0jgig-2"
})(["font-size:", "px;border-radius:0 0 ", " 0;", " ", ";z-index:2;"], themeGet('fontSizes.0'), themeGet('radius'), flexAuto, color);
const RelativeHide = /*#__PURE__*/styled(Hide).withConfig({
  displayName: "Flag__RelativeHide",
  componentId: "sc-e0jgig-3"
})(["position:relative;"]);
const StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "Flag__StyledFlex",
  componentId: "sc-e0jgig-4"
})(["", ""], applyVariations('Flag'));
/**
 * @public
 */
export const Flag = ({
  color = 'white',
  bg = 'green',
  children,
  pl = [1, 3],
  pr = null,
  py = [1, 2],
  width,
  ...props
}) => React.createElement(StyledFlex, {
  width: width,
  ...props,
  ml: [0, -2]
}, React.createElement(RelativeHide, {
  xs: true
}, React.createElement(FlagShadow, {
  width: '4px',
  mr: -2,
  mb: -2,
  color: hasPaletteColor({
    color,
    ...props
  }) ? color : bg
})), React.createElement(FlagBody, {
  flexAuto: !!width,
  color: color,
  bg: hasPaletteColor({
    color,
    ...props
  }) ? false : bg,
  pl: pl,
  pr: pr,
  py: py
}, children), React.createElement(FlagRight, {
  width: '18px',
  color: hasPaletteColor({
    color,
    ...props
  }) ? color : bg,
  ml: -2
}));
Flag.displayName = 'Flag';